import { TDealType, EChartType } from '../../../types/charts';
import { ROUBLE_SIGN, ROUBLE_PER_MONTH_SIGN, ROUBLE_PER_DAY_SIGN } from '../../../constants/prices';
import { PERCENTAGE } from '../../../constants/symbols';

export function getPriceUnit(dealType: TDealType, chartType: EChartType) {
  if (EChartType.Price === chartType) {
    switch (dealType) {
      case 'sale':
        return ROUBLE_SIGN;
      case 'rent':
        return ROUBLE_PER_MONTH_SIGN;
      case 'rentDay':
        return ROUBLE_PER_DAY_SIGN;
    }
  }

  if (EChartType.Mortgage === chartType) {
    return PERCENTAGE;
  }

  return '';
}
